import React from "react";
import * as Icons from "lucide-react";
import { SKILLS } from "../../data";
import { Reveal } from "./Reveal";

export const Skills = () => (
  <section
    id="expertise"
    data-testid="skills-section"
    className="relative py-24 sm:py-32 bg-[#050505]"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-[#E879F9] font-bold mb-4">
          01 — The Skillset
        </p>
        <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-6xl max-w-3xl leading-[0.95]">
          Everything a show needs, <span className="text-[#b533ff]">handled.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {SKILLS.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Star;
          return (
            <Reveal key={s.n} delay={(i % 4) * 0.06}>
              <div
                data-testid={`skill-card-${s.n}`}
                className="group h-full bg-[#0a0a0c] p-8 hover:bg-[#121216] transition-colors duration-400 relative"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-display text-xs text-gray-600">{s.n}</span>
                  <Icon
                    size={24}
                    className="text-[#b533ff] group-hover:scale-110 group-hover:drop-shadow-[0_0_10px_rgba(181,51,255,0.8)] transition-all duration-300"
                  />
                </div>
                <h3 className="font-display font-bold uppercase text-lg mb-3 text-white">
                  {s.title}
                </h3>
                <p className="text-sm text-gray-400 leading-relaxed font-light">{s.desc}</p>
                <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#b533ff] group-hover:w-full transition-all duration-500" />
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
